import KBBDealIndicator from './KBBDealIndicator';
export default KBBDealIndicator;